export const INVITE_ACTION = '[Invite Action] Invite';
export const CONFIRMED_INVITE_ACTION =
    '[Invite Action] Confirmed Invite';

export const BULK_INVITE_ACTION = '[Invite Action] Bulk Invite';
export const CONFIRMED_BULK_INVITE_ACTION =
    '[Invite Action] Bulk Confirmed Invite';

export const GET_INVITATIONS = '[Invite Action] Get Invitations';
export const CONFIRMED_GET_INVITATIONS = '[Invite Action] Confirmed Get Invitations';

export const CANCEL_INVITE_ACTION = '[Invite Action] Cancel Invite';
export const CONFIRMED_CANCEL_INVITE_ACTION =
    '[Invite Action] Confirmed Cancel Invite';

    export const INVITE_RESET_ACTION =
    '[Invite Action] Invite Reset';

